// ============================================================================
// FRENCH TRANSLATIONS - CHAPTER 2: L'EXODE
// ============================================================================
// Niveaux 14-26 (13 niveaux, 39 questions)

export const chapter2Translations = {
  name: "L'Exode",
  description: "La libération du peuple de Dieu... Connaître Dieu transforme nos vies",
  
  spiritualWisdom: {
    principle: "La connaissance de Dieu libère et transforme",
    scripture: "Vous connaîtrez la vérité, et la vérité vous affranchira (Jean 8:32)",
    application: "Comme Israël fut libéré d'Égypte, la connaissance de Dieu nous libère de l'esclavage spirituel"
  },
  
  levels: {
    14: {
      name: "Moïse Sauvé des Eaux",
      challenge: "Une femme conçut et enfanta un fils. Elle vit qu'il était beau...",
      easy: {
        question: "Dans quoi la mère de Moïse l'a-t-elle caché ?",
        options: ["Une grotte", "Une corbeille de jonc", "Un panier", "Une maison"],
        hint: "Ce récipient flottait sur le Nil",
        funFact: "🏺 La corbeille de jonc était enduite de poix pour être étanche!"
      },
      medium: {
        question: "Qui a trouvé Moïse dans les roseaux ?",
        options: [
          "La fille de Pharaon",
          "Une servante égyptienne", 
          "Sa sœur Miriam",
          "Un prêtre égyptien"
        ],
        hint: "Une membre de la famille royale égyptienne",
        funFact: "👑 Ironiquement, c'est la famille de Pharaon qui sauve celui qui le défiera!"
      },
      hard: {
        question: "Comment la Providence divine utilise même nos ennemis ?",
        options: [
          "En les convertissant",
          "En orchestrant les circonstances pour accomplir ses desseins",
          "En les punissant",
          "En les ignorant"
        ],
        hint: "Il s'agit de voir la main de Dieu dans les événements",
        funFact: "✨ Moïse grandit dans le palais de celui qui opprimait son peuple!"
      }
    },
    
    15: {
      name: "Le Buisson Ardent",
      challenge: "L'ange de l'Éternel lui apparut dans une flamme de feu...",
      easy: {
        question: "Que devait enlever Moïse devant le buisson ardent ?",
        options: ["Ses bijoux", "Ses sandales", "Son manteau", "Son turban"],
        hint: "Ce qu'on porte aux pieds",
        funFact: "👡 Se déchausser exprime le respect sur une terre sainte!"
      },
      medium: {
        question: "Quel nom Dieu révèle-t-il à Moïse ?",
        options: [
          "L'Éternel",
          "JE SUIS CELUI QUI SUIS", 
          "L'Tout-Puissant",
          "Le Créateur"
        ],
        hint: "Un nom qui exprime l'existence absolue",
        funFact: "🔥 YHWH (Je Suis) révèle l'essence éternelle de Dieu!"
      },
      hard: {
        question: "Que nous enseigne le buisson qui brûle sans se consumer ?",
        options: [
          "La magie existe",
          "Dieu transcende les lois naturelles",
          "Le feu est sacré",
          "Les plantes sont magiques"
        ],
        hint: "Il s'agit de la nature divine qui dépasse notre compréhension",
        funFact: "🌿 Le buisson symbolise que la présence divine sanctifie sans détruire!"
      }
    },

    16: {
      name: "Les Dix Plaies d'Égypte",
      challenge: "Pharaon endurcit son cœur et ne les écouta point...",
      easy: {
        question: "Quelle fut la première plaie d'Égypte ?",
        options: ["Les grenouilles", "L'eau changée en sang", "Les mouches", "Les poux"],
        hint: "Elle toucha le Nil, source de vie pour l'Égypte",
        funFact: "🩸 Le Nil était adoré comme un dieu, et Dieu montra sa supériorité!"
      },
      medium: {
        question: "Quelle fut la dernière et plus terrible des plaies ?",
        options: [
          "La grêle",
          "Les ténèbres", 
          "La mort des premiers-nés",
          "Les sauterelles"
        ],
        hint: "Cette plaie toucha directement les familles",
        funFact: "😢 Cette plaie brisa enfin l'orgueil de Pharaon et libéra Israël!"
      },
      hard: {
        question: "Pourquoi Dieu endurcit-il le cœur de Pharaon ?",
        options: [
          "Pour le punir",
          "Pour manifester sa gloire et sa puissance",
          "Par méchanceté",
          "Pour prolonger les souffrances"
        ],
        hint: "Il s'agit de révéler qui est le vrai Dieu",
        funFact: "⚡ Les plaies démontrent que YHWH est plus puissant que tous les dieux égyptiens!"
      }
    },

    17: {
      name: "La Pâque",
      challenge: "Prenez un agneau... et vous mettrez de son sang sur les poteaux...",
      easy: {
        question: "Où les Israélites devaient-ils mettre le sang de l'agneau ?",
        options: [
          "Sur leurs vêtements",
          "Sur les linteaux et poteaux des portes",
          "Sur leurs fronts",
          "Dans des coupes"
        ],
        hint: "À l'entrée de leurs maisons",
        funFact: "🩸 Le sang sur la porte était le signe de protection divine!"
      },
      medium: {
        question: "Comment devaient-ils manger l'agneau pascal ?",
        options: [
          "Assis confortablement",
          "En famille seulement",
          "Les reins ceints, sandales aux pieds, bâton à la main",
          "En silence"
        ],
        hint: "Prêts pour le départ",
        funFact: "🚶 Ils devaient être prêts à partir rapidement vers la liberté!"
      },
      hard: {
        question: "Comment l'Agneau pascal préfigure-t-il le Christ ?",
        options: [
          "Par sa blancheur",
          "Par son sacrifice substitutif qui sauve de la mort",
          "Par sa douceur",
          "Par son âge"
        ],
        hint: "Il s'agit du sacrifice qui épargne de la condamnation",
        funFact: "🐑 Jésus est appelé 'l'Agneau de Dieu qui ôte le péché du monde'!"
      }
    },

    18: {
      name: "La Traversée de la Mer Rouge",
      challenge: "Moïse étendit sa main sur la mer...",
      easy: {
        question: "Comment les Israélites ont-ils traversé la mer ?",
        options: [
          "En bateau",
          "À la nage", 
          "À pied sec",
          "En radeau"
        ],
        hint: "Le fond de la mer était praticable",
        funFact: "🌊 Dieu transforma un obstacle en chemin de libération!"
      },
      medium: {
        question: "Qu'est-il arrivé aux Égyptiens qui poursuivaient ?",
        options: [
          "Ils ont fait demi-tour",
          "Ils ont été engloutis par les eaux",
          "Ils se sont perdus",
          "Ils ont rejoint Israël"
        ],
        hint: "Les eaux sont retombées sur eux",
        funFact: "⚔️ L'armée la plus puissante du monde fut détruite en un instant!"
      },
      hard: {
        question: "Que symbolise cette traversée dans notre vie spirituelle ?",
        options: [
          "La fuite des problèmes",
          "Le passage de l'esclavage du péché à la liberté en Dieu",
          "La supériorité d'Israël",
          "La destruction des ennemis"
        ],
        hint: "Il s'agit d'une transformation spirituelle",
        funFact: "🗽 La mer Rouge représente le baptême : mort à l'ancien, vie nouvelle!"
      }
    },

    19: {
      name: "La Manne dans le Désert",
      challenge: "Qu'est-ce que c'est ? Car ils ne savaient pas ce que c'était...",
      easy: {
        question: "Combien de temps la manne est-elle tombée ?",
        options: ["10 ans", "20 ans", "40 ans", "50 ans"],
        hint: "Le même nombre que les années dans le désert",
        funFact: "🍞 Pendant 40 ans, Dieu nourrit miraculeusement 2 millions de personnes!"
      },
      medium: {
        question: "Que se passait-il si on gardait la manne plus d'un jour ?",
        options: [
          "Elle devenait plus savoureuse",
          "Elle se multipliait",
          "Elle pourrissait et sentait mauvais",
          "Elle durcissait"
        ],
        hint: "Sauf le vendredi pour le sabbat",
        funFact: "🪱 Dieu enseignait ainsi la dépendance quotidienne envers Lui!"
      },
      hard: {
        question: "Comment la manne nous enseigne-t-elle la confiance ?",
        options: [
          "En stockant pour l'avenir",
          "En comptant sur la providence quotidienne de Dieu",
          "En travaillant plus dur",
          "En partageant équitablement"
        ],
        hint: "Il s'agit de faire confiance jour après jour",
        funFact: "🙏 'Donne-nous aujourd'hui notre pain quotidien' vient de cette expérience!"
      }
    },

    20: {
      name: "L'Eau du Rocher",
      challenge: "Tu frapperas le rocher, et il en sortira de l'eau...",
      easy: {
        question: "Avec quoi Moïse devait-il frapper le rocher ?",
        options: ["Sa main", "Sa verge", "Une pierre", "Un marteau"],
        hint: "L'instrument des miracles de Moïse",
        funFact: "⚡ La verge de Moïse était l'instrument de la puissance divine!"
      },
      medium: {
        question: "Pourquoi le peuple murmurait-il contre Moïse ?",
        options: [
          "Il n'y avait pas d'eau à boire",
          "La nourriture manquait",
          "Le chemin était trop long",
          "Il faisait trop chaud"
        ],
        hint: "Un besoin vital dans le désert",
        funFact: "💧 L'eau est plus essentielle que la nourriture pour la survie!"
      },
      hard: {
        question: "Que représente spirituellement l'eau du rocher ?",
        options: [
          "Les ressources naturelles",
          "La vie spirituelle qui jaillit de Christ, le Rocher",
          "La récompense des efforts",
          "La magie divine"
        ],
        hint: "Paul dit que ce rocher était Christ",
        funFact: "🗿 Christ est le Rocher frappé duquel jaillit la vie éternelle!"
      }
    },

    21: {
      name: "Le Mont Sinaï",
      challenge: "Tout le mont Sinaï était en fumée, parce que l'Éternel y était descendu...",
      easy: {
        question: "Combien de commandements Dieu a-t-il donnés ?",
        options: ["5", "7", "10", "12"],
        hint: "Un nombre rond et parfait",
        funFact: "📜 Les Dix Commandements sont le fondement moral de l'humanité!"
      },
      medium: {
        question: "Sur quoi les commandements étaient-ils écrits ?",
        options: [
          "Du papyrus",
          "Du parchemin",
          "Deux tables de pierre",
          "Du bronze"
        ],
        hint: "Un matériau durable écrit par le doigt de Dieu",
        funFact: "✍️ Écrits par Dieu lui-même pour montrer leur importance éternelle!"
      },
      hard: {
        question: "Quel est l'objectif des commandements divins ?",
        options: [
          "Punir les hommes",
          "Révéler la sainteté de Dieu et guider vers le bonheur",
          "Créer des règles complexes",
          "Séparer les peuples"
        ],
        hint: "Il s'agit de révéler le caractère divin et le chemin du bien",
        funFact: "⚖️ Les commandements révèlent l'amour : amour de Dieu et du prochain!"
      }
    },

    22: {
      name: "Le Veau d'Or",
      challenge: "Fais-nous un dieu qui marche devant nous...",
      easy: {
        question: "Avec quoi Aaron fit-il le veau d'or ?",
        options: [
          "Des pièces d'or",
          "Les boucles d'oreilles en or du peuple",
          "Des bijoux précieux",
          "De l'or du désert"
        ],
        hint: "Des bijoux personnels donnés par le peuple",
        funFact: "👂 Le peuple donna ses bijoux pour créer sa propre idole!"
      },
      medium: {
        question: "Quelle fut la réaction de Moïse en voyant le veau ?",
        options: [
          "Il pleura",
          "Il pria",
          "Il brisa les tables de la loi",
          "Il se mit en colère seulement"
        ],
        hint: "Un geste symbolique de l'alliance brisée",
        funFact: "💥 Briser les tables symbolisait que l'alliance était rompue!"
      },
      hard: {
        question: "Pourquoi l'idolâtrie est-elle si dangereuse spirituellement ?",
        options: [
          "Elle coûte cher",
          "Elle détourne le cœur du vrai Dieu vers des créatures",
          "Elle divise les familles",
          "Elle est interdite"
        ],
        hint: "Il s'agit de donner à la créature ce qui revient au Créateur",
        funFact: "💔 L'idolâtrie brise la relation exclusive avec le Dieu vivant!"
      }
    },

    23: {
      name: "Le Tabernacle",
      challenge: "Ils me feront un sanctuaire, et j'habiterai au milieu d'eux...",
      easy: {
        question: "Comment appelait-on la tente sacrée des Israélites ?",
        options: ["Le Temple", "Le Tabernacle", "Le Sanctuaire", "L'Arche"],
        hint: "Le nom signifie 'tente de rencontre'",
        funFact: "⛺ Le Tabernacle était la 'maison mobile' de Dieu avec son peuple!"
      },
      medium: {
        question: "Que contenait l'Arche de l'Alliance ?",
        options: [
          "Les bijoux du grand-prêtre",
          "Les tables de la loi, la manne, la verge d'Aaron",
          "Des pièces d'or",
          "Les rouleaux de la Torah"
        ],
        hint: "Trois objets symbolisant l'alliance avec Dieu",
        funFact: "📦 L'Arche contenait les 'souvenirs' de la fidélité divine!"
      },
      hard: {
        question: "Que symbolise le Tabernacle dans notre relation avec Dieu ?",
        options: [
          "Un bâtiment religieux",
          "La présence de Dieu qui habite parmi et en nous",
          "Un lieu de sacrifice seulement",
          "Un symbole national"
        ],
        hint: "Il s'agit de la présence divine accessible",
        funFact: "🏠 'Votre corps est le temple du Saint-Esprit' selon Paul!"
      }
    },

    24: {
      name: "Le Grand-Prêtre Aaron",
      challenge: "Tu consacreras Aaron et ses fils pour qu'ils soient mes sacrificateurs...",
      easy: {
        question: "Qui était le premier grand-prêtre d'Israël ?",
        options: ["Moïse", "Aaron", "Josué", "Éléazar"],
        hint: "Le frère de Moïse",
        funFact: "👨‍⚕️ Aaron fonda la lignée sacerdotale qui dura plus de 1000 ans!"
      },
      medium: {
        question: "Que portait le grand-prêtre sur sa poitrine ?",
        options: [
          "Une croix d'or",
          "Le pectoral avec les douze pierres précieuses",
          "Un médaillon",
          "Une chaîne en or"
        ],
        hint: "Douze pierres représentant les douze tribus",
        funFact: "💎 Le grand-prêtre portait symboliquement tout Israël sur son cœur!"
      },
      hard: {
        question: "Comment Jésus accomplit-il le rôle de Grand-Prêtre ?",
        options: [
          "En portant des vêtements sacrés",
          "En offrant son propre sang une fois pour toutes",
          "En servant dans le Temple",
          "En descendant d'Aaron"
        ],
        hint: "Il s'agit d'un sacrifice parfait et définitif",
        funFact: "✝️ Jésus est Grand-Prêtre éternel selon l'ordre de Melchisédek!"
      }
    },

    25: {
      name: "Les Sacrifices",
      challenge: "Si quelqu'un d'entre vous fait une offrande à l'Éternel...",
      easy: {
        question: "Quel était le sacrifice quotidien au Tabernacle ?",
        options: [
          "Le sacrifice de paix",
          "L'holocauste du matin et du soir",
          "Le sacrifice pour le péché",
          "L'offrande de gâteaux"
        ],
        hint: "Deux fois par jour, matin et soir",
        funFact: "🔥 Le feu sur l'autel ne devait jamais s'éteindre!"
      },
      medium: {
        question: "Que symbolisait l'imposition des mains sur l'animal ?",
        options: [
          "La bénédiction",
          "Le transfert des péchés sur la victime",
          "L'affection pour l'animal",
          "La consécration"
        ],
        hint: "Un geste de substitution",
        funFact: "🤲 L'animal mourait à la place du pécheur - principe de substitution!"
      },
      hard: {
        question: "Comment ces sacrifices préfigurent-ils l'œuvre du Christ ?",
        options: [
          "Par leur nombre",
          "Par la substitution : l'innocent meurt pour le coupable",
          "Par leur coût",
          "Par leur beauté"
        ],
        hint: "Il s'agit du principe de l'innocent qui prend la place du coupable",
        funFact: "🐑 'Il a été blessé pour nos péchés, brisé pour nos iniquités'!"
      }
    },

    26: {
      name: "Aux Frontières de la Terre Promise",
      challenge: "J'enverrai devant toi un ange, et je chasserai les Cananéens...",
      easy: {
        question: "Combien d'espions furent envoyés pour explorer la Terre Promise ?",
        options: ["10", "12", "20", "40"],
        hint: "Un par tribu d'Israël",
        funFact: "🕵️ Seuls 2 des 12 espions firent un rapport encourageant!"
      },
      medium: {
        question: "Quels espions encouragèrent le peuple à entrer dans la terre ?",
        options: [
          "Aaron et Moïse",
          "Josué et Caleb",
          "Gad et Aser",
          "Ruben et Siméon"
        ],
        hint: "Deux hommes de foi qui virent les promesses de Dieu",
        funFact: "🦁 Josué et Caleb furent les seuls de leur génération à entrer en Canaan!"
      },
      hard: {
        question: "Pourquoi Israël a-t-il erré 40 ans dans le désert ?",
        options: [
          "Pour les punir",
          "À cause de leur incrédulité face aux promesses divines",
          "Pour les entraîner au combat",
          "Pour trouver le bon chemin"
        ],
        hint: "Il s'agit d'un manque de confiance en Dieu",
        funFact: "🏜️ Une génération entière dut mourir à cause de l'incrédulité!"
      }
    }
  }
};

export default chapter2Translations;
